import { render, staticRenderFns } from "./VerCertificadoModal.vue?vue&type=template&id=2c2e48c0&"
import script from "./VerCertificadoModal.vue?vue&type=script&lang=ts&"
export * from "./VerCertificadoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports